import { createBodyVarApplier } from '../../web/styles/customPageTheme';

// Replacements for the pale Levitate-blue surfaces on the satisfaction survey, applied only when
// the account has custom primary-button colors so the blue doesn't clash with the customer's brand.
// These surfaces are static chrome rather than controls, so they go neutral instead of taking the
// button color, matching how the scheduler treats its own chrome.
//
// Survey styles read each var with the existing pale blue as its var() fallback, so pages without
// customization are untouched.
export const SURVEY_ACCENT_VARS: Record<string, string> = {
	'--survey-accent-surface': 'var(--palette-shuffle-gray)',
	'--survey-accent-text': 'var(--palette-top-hat-black)',
};

/** Applies the accent vars to <body> and returns the matching cleanup. */
export const applySurveyAccentVars = createBodyVarApplier(SURVEY_ACCENT_VARS);
